/* eslint-disable */
export default {
  hide: 'Hide',
  end: 'End',
  keypad: 'Keypad',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
